module.exports = __webpack_public_path__ + "static/media/50316893_00201_0182_Large 5.bafe982a.JPG";